import { MEDIA } from '~/consts';

export default {
  data() {
    return {
      show_media_library_modal: false
    }
  },

  methods: {
    setMedias(medias) {

    },
    getMedias(ids) {
      if (this.isEmpty(ids)) {
        return;
      }

      this.$axios.post(MEDIA.GET_SELECTED, {
        media_ids: ids
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          this.setMedias(data.data)
        } else {
          toast.danger(data.applicationSystem.message)
        }
      });
    }
  }
}
